export default __webpack_public_path__ + "static/media/ashe_coxon.4f658dd5.jpg";